<template>
  <div class="w-8 h-4 relative rounded-[100px] inline-flex justify-start items-center transition-colors"
       :class="[modelValue ? 'bg-btn-primary' : 'bg-toggle-off', disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer']" @click="toggle">
    <div class="w-3 h-3 absolute bg-surface-1 rounded-full shadow transition-all" :class="modelValue ? 'left-[18px]' : 'left-[2px]'" style="top: 2px;"></div>
  </div>
</template>

<script>
export default {
  name: 'FusionSwitch',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit('update:modelValue', !this.modelValue);
    }
  }
};
</script>
